const Loader = () => {
  return (
    <div
      className="spinner-border spinner-border-sm text-light"
      role="status"
      style={{ marginRight: "5px" }}
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  );
};
 
export default Loader;